<template>
    
      <mw-dialog title="选择部门机构" size="mini_mini" :footerButton="btns" ref="zgDeptDialog" :close-on-click-modal="false">
        <mw-tree :url="deptTreeUrl" :multipleLeaf="false" 
                  :async="false" :expandedFirst="true"
                  ref="deptTree" :multiple="true" class="mw-dialog-body" ></mw-tree>     
      </mw-dialog>
    
   
</template>
<script >
    export default {
        data() {
          return {
            deptTreeUrl: 'api/org/getUnitTree', 
            btns: [{
              label: '全选',
              func: this.selectAll
            },{
              label: '不选',
              func: this.resetChecked,
               type: 'default'
            },{
              label: '取消',
              func: this.cancelDept,
               type: 'default'
            },{
              label: '确定',
              func: this.confirmDept
            }]    
          }
        },
      methods:{
        selectAll(){
          this.mwRef('deptTree').checkAll();
        },
        resetChecked(){
          this.mwRef('deptTree').unCheckAll();
        },

        confirmDept(){
          this.$emit("confirm",this.mwRef('deptTree').getSelected());
          this.cancelDept();
        },
        
        cancelDept(){
          this.mwRef('zgDeptDialog').hide();
        },
        getValue(){
          return this.mwRef('deptTree').getSelected();
        },
        show(){
          this.mwRef('zgDeptDialog').show();
        }
     
      }
    }
</script>




// WEBPACK FOOTER //
// src/modules/index/views/systemSet/org/user/firstDept.vue